import {
  WSActions,
  WSCard,
  WSEmptyState,
  WSList
} from "@wingspanhq/fe-component-library";
import { EditPayeeSetupParams } from "./index";
import { SetupRouteComponentProps } from "../../../../shared/components/FlowSetup";
import React from "react";
import { ComplianceEntityType } from "@wingspanhq/wingspan-api-sdk";

type Props = SetupRouteComponentProps<EditPayeeSetupParams>;

export const EditPayeeTaxInfoVerificationSuccess: React.FC<Props> = ({
  onNext,
  params
}) => {
  const tinTypeLabel =
    params?.complianceEntity?.type === ComplianceEntityType.INDIVIDUAL
      ? "SSN"
      : "EIN";

  return (
    <WSList gap="2XL">
      <WSCard>
        <WSEmptyState
          type="done"
          title={`Contractor’s ${tinTypeLabel} was verified`}
          description={`The IRS has confirmed the contractor’s ${tinTypeLabel}. Once verified, the tax information provided cannot be edited without re-verification. Click continue for the next step`}
          orientation="horizontal"
        />
      </WSCard>
      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Continue",
            onClick: onNext
          }
        ]}
      />
    </WSList>
  );
};
